import {User} from '../app/pages/tickets/components/TicketDetails'
import {REACT_APP_API_TICKETS} from '../config'
import axios from './interceptors/axios.global'

const API_TICKETS = `${REACT_APP_API_TICKETS}`
const API = 'api'

const getTickets = async (params?: {
  skip?: number
  take?: number
  search?: string
  startDate?: string
  endDate?: string
  statusName?: string
  assignedTo?: string
  priority?: string
  user: User
  creator: User
  providerId?: number | string
  productType?: string
  title?: string
}) => {
  return axios.get(`${API_TICKETS}/${API}/Tickets`, {params})
}

const getTicketById = async (id: string) => {
  return axios.get(`${API_TICKETS}/${API}/Tickets/${id}`)
}

const createTicket = async (ticket: any) => {
  return axios.post(`${API_TICKETS}/${API}/Tickets`, ticket)
}

// Get comments for a ticket
const getTicketComments = async (ticketId: string) => {
  return axios.get(`${API_TICKETS}/${API}/Tickets/Comments/GetCommentsToTicket/${ticketId}`)
}

// Create a new comment on a ticket (supports file uploads)
const createComment = async (payload: {
  Text: string
  TicketId: string
  Actors?: string[]
  Files?: File[]
}) => {
  const formData = new FormData()
  formData.append('Text', payload.Text)
  formData.append('TicketId', payload.TicketId)
  if (payload.Actors && payload.Actors.length > 0) {
    payload.Actors.forEach((actor) => formData.append('Actors', actor))
  }
  if (payload.Files && payload.Files.length > 0) {
    payload.Files.forEach((file) => formData.append('Files', file))
  }

  return axios.post(`${API_TICKETS}/${API}/Comments/CreateComment`, formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  })
}

// Escalate a ticket
const escalateTicket = async (
  id: string,
  payload: {
    assignedTo: 'tygo' | 'provider' | 'customer_service'
    comment: string
    actors: string[]
  }
) => {
  return axios.put(`${API_TICKETS}/${API}/Tickets/${id}/escalate`, payload)
}

// Update ticket status
const updateTicketStatus = async (
  id: string,
  payload: {
    statusName: string
    comment: string
    actors: string[]
  }
) => {
  return axios.put(`${API_TICKETS}/${API}/Tickets/${id}/status`, payload)
}

// Get list of statuses
const getStatuses = async () => {
  return axios.get(`${API_TICKETS}/${API}/Status`)
}

const updateCommentVisibility = async (commentId: string, visibilityStates: string[]) => {
  return axios.put(`${API_TICKETS}/${API}/Comments/UpdateCommentVisibility/${commentId}`, {
    visibilityStates,
  })
}

const getActors = async () => {
  return axios.get(`${API_TICKETS}/${API}/Actors`)
}

const getTicketHistory = async (ticketId: string) => {
  return axios.get(`${API_TICKETS}/${API}/Tickets/${ticketId}/history`)
}

const TicketsService = {
  getTickets,
  getTicketById,
  createTicket,
  getTicketComments,
  createComment,
  escalateTicket,
  updateTicketStatus,
  getStatuses,
  updateCommentVisibility,
  getActors,
  getTicketHistory,
}

export default TicketsService
